var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "white",
    fillOpacity: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    stroke: "black",
    strokeOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39623 7.65377C8.19121 7.44874 7.85879 7.44874 7.65377 7.65377C7.44874 7.85879 7.44874 8.19121 7.65377 8.39623L10.2575 11L7.65377 13.6038C7.44874 13.8088 7.44874 14.1412 7.65377 14.3462C7.85879 14.5513 8.19121 14.5513 8.39623 14.3462L11 11.7425L13.6038 14.3462C13.8088 14.5513 14.1412 14.5513 14.3462 14.3462C14.5513 14.1412 14.5513 13.8088 14.3462 13.6038L11.7425 11L14.3462 8.39623C14.5513 8.19121 14.5513 7.85879 14.3462 7.65377C14.1412 7.44874 13.8088 7.44874 13.6038 7.65377L11 10.2575L8.39623 7.65377Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.2cbedf54d5232bcd19be3e8f0d416a42.svg";
export { ForwardRef as ReactComponent };